import { Flex, Icon, Tag, TagLabel, TagLeftIcon } from '@chakra-ui/react';
import { MdEdit, MdRemoveRedEye } from 'react-icons/md';
import {
  ApiKeyScope,
  ScopeDescription,
} from '../../../models/api-key/dto/api-key.dto';
import { copy } from '../copy';

type Props = { scope: ApiKeyScope; descriptions: ScopeDescription[] };

/**
 * Scope chip — icon for capability (eye/pencil) on a neutral chip so color
 * stays reserved for status. Labels are humanized via the /scopes endpoint.
 */
export function ScopeChip({ scope, descriptions }: Props) {
  const description = descriptions.find((d) => d.scope === scope);
  const local = copy.scopes[scope];
  const label = local?.label ?? description?.label ?? scope;
  const tooltip = local?.description ?? description?.description;
  const isWrite = scope.endsWith(':write');
  return (
    <Tag size="sm" variant="subtle" colorScheme="gray" title={tooltip}>
      <TagLeftIcon as={isWrite ? MdEdit : MdRemoveRedEye} />
      <TagLabel>{label}</TagLabel>
    </Tag>
  );
}

type ListProps = { scopes: ApiKeyScope[]; descriptions: ScopeDescription[] };

export function ScopeChipList({ scopes, descriptions }: ListProps) {
  return (
    <Flex gap={1.5} wrap="wrap">
      {scopes.map((scope) => (
        <ScopeChip
          key={scope}
          scope={scope}
          descriptions={descriptions}
        />
      ))}
    </Flex>
  );
}
